import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { validationSchema } from '../../../../utils/validationUtils'
import sty from './SignupForm.module.css'
import { menu } from '../../../../constants'
import PropTypes from 'prop-types'; 

const SignupForm = ({ onSubmit, errorMessage }) => {
    // prop
    SignupForm.propTypes = {
        onSubmit: PropTypes.func.isRequired,
        errorMessage: PropTypes.string,
    };

    // フォームのstateを更新
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: 'onBlur', // フォーカスが外れたときにバリデーションを実行
    })

    const [passwordVisible, setPasswordVisible] = useState(false)
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible)
    }

    return (
        <>
            <div className="page-tit">
                <div className="page-tit-outer">
                    <p className="page-tit-txt">アカウント登録</p>
                    <div className="page-tit-border"></div>
                </div>
            </div>
            <div className="inner-container">
                {errorMessage && (
                    <p className="account-error-msg">{errorMessage}</p>
                )}
                <div className={sty['sign-up__mail']}>
                    <div className={sty['sign-up__mail-mail-tit']}>
                        <label htmlFor="email">メールアドレス</label>
                    </div>
                    <div className={sty['sign-up__mail-mail-tit']}>
                        <div className={sty['sign-up__mail-mail-ex']}>
                            <input
                                {...register(
                                    'email',
                                    validationSchema.email
                                )}
                                type="email"
                                id="email"
                                autoComplete="email"
                                className={sty['sign-up__mail-input-field']}
                                placeholder="taro.yamada@example.com"
                            />
                            {errors.email && (
                                <p className="form__validation-msg">
                                    {errors.email.message}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                <div className={sty['sign-up__pass']}>
                    <div className={sty['sign-up__pass-pass-tit']}>
                        <label htmlFor="password">パスワード</label>
                    </div>
                    <div className={sty['sign-up__pass-pass-tit']}>
                        <div className={sty['sign-up__pass-pass-ex']}>
                            <input
                                {...register(
                                    'password',
                                    validationSchema.password
                                )}
                                type={passwordVisible ? 'text' : 'password'}
                                className={sty['sign-up__pass-input-field']}
                                placeholder="パスワードを入力してください"
                                id="password"
                            />
                            {errors.password && (
                                <p className="form__validation-msg">
                                    {errors.password.message}
                                </p>
                            )}

                            <img
                                src={
                                    passwordVisible
                                        ? '/images/open.svg'
                                        : '/images/hidden.svg'
                                }
                                alt="パスワード表示・非表示"
                                className={sty['sign-up__pass-toggle']}
                                onClick={togglePasswordVisibility}
                            />
                        </div>
                        <div
                            className={
                                sty['sign-up__pass-available-symbols']
                            }
                        >
                            使用可能な記号 @$!%*?&
                        </div>
                    </div>

                    <div className={sty['sign-up__flex']}>
                        <div className={sty['sign-up__toggle-button']}>
                            <input
                                {...register(
                                    'terms',
                                    validationSchema.terms
                                )}
                                id="sign-up__toggle"
                                className={sty['sign-up__toggle-agre']}
                                type="checkbox"
                            />
                            <label
                                htmlFor="sign-up__toggle"
                                className={sty['sign-up__toggle-label']}
                            />
                        </div>
                        <div className={sty['sign-up__switch-agree']}>
                            <Link to="/guide" target="_blank">
                                利用規約
                            </Link>
                            ・
                            <Link to="/privacy" target="_blank">
                                プライバシーポリシー
                            </Link>
                            に同意します
                        </div>
                    </div>
                    {errors.terms && (
                        <p className="form__validation-msg">
                            {errors.terms.message}
                        </p>
                    )}
                </div>
                <div className="primary-btns">
                    <button 
                        type="submit" 
                        className="primary-btn btn-large"
                        onClick={handleSubmit(onSubmit)}
                    >
                        登録
                    </button>
                    <div className="link__under-btn">
                        <Link to={menu.ENGINEER.SIGNIN.PATH}>
                            ログインはこちら
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SignupForm